import IframeViewer from 'core/modules/atoms/IframeViewer/IframeViewer';
import PropTypes from 'prop-types';
import React from 'react';
import useMaterialPreviewLink from './useMaterialPreviewLink';

function MaterialPreviewLink({ course, material }) {
  const { onOpenLink } = useMaterialPreviewLink({ material, course });

  return (
    <>
      {!!material.is_embed && (
        <IframeViewer
          url={material.content_url}
          title={material.name}
          description={material.description}
          contentGuid={material.content_guid}
          jobGuid={material.job?.id}
        />
      )}

      {!material.is_embed && (
        <button className="material-preview-link" onClick={onOpenLink}>
          <div className="lesson-element-item__name">{material.name}</div>
          <div className="lesson-element-item__type">{material.content_url}</div>
        </button>
      )}
    </>
  );
}

MaterialPreviewLink.propTypes = {
  course: PropTypes.object.isRequired,
  material: PropTypes.shape({
    content_url: PropTypes.string,
    description: PropTypes.string,
    is_embed: PropTypes.bool,
    name: PropTypes.string,
    type: PropTypes.string,
    content_guid: PropTypes.string,
    job: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default MaterialPreviewLink;
